import { StyleSheet } from 'react-native';

const ResourceDownloadImage = ({ style }) => {
  const oneX = require('./resource-download.jpg');
  const twoX = require('./resource-download@2x.jpg');
  return (
    <img
      src={twoX}
      alt=""
      style={{ ...StyleSheet.flatten(style), objectFit: 'cover' }}
      srcSet={`${oneX}, ${twoX} 2x`}
    />
  );
};

export { ResourceDownloadImage };
